export function parseToJson(stringifyObj = "", defaultValue = {}) {
  try {
    return JSON.parse(stringifyObj);
  } catch (error) {
    return defaultValue;
  }
}
